import { Button, Card, Stack, Box, Grid, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function BecomeAWriter() {
  const { t } = useTranslation();

  return (
    <Card variant='outlined'>
      <Grid container columnSpacing={2}>
        <Grid size={{ xs: 12, md: 8, lg: 6 }}>
          <Stack
            direction='column'
            sx={{
              paddingY: { xs: 3 },
              paddingX: { xs: 2, sm: 3, md: 6 },
            }}
          >
            <Typography
              variant='h2'
              sx={{
                marginY: 1,
              }}
            >
              {t('becomeAuthor.advertHeader')}
            </Typography>
            <Typography
              variant='body2'
              sx={{
                marginY: 1,
              }}
            >
              {t('becomeAuthor.advertContent')}
            </Typography>
            <Box>
              <Button
                variant='text'
                size='large'
                endIcon={<ArrowForward fontSize='small' />}
                href='https://www.almainsights.fi/juridiikan-palvelut/kirjoita-juridiikan-ajankohtaiset-palveluun/'
                sx={{ textDecoration: 'none', textTransform: 'none' }}
                // Do not change the ID! It is used for Google Analytics tracking click event tracking.
                id='JA_become_author_cta'
              >
                {t('becomeAuthor.advertCTA')}
              </Button>
            </Box>
          </Stack>
        </Grid>
        <Grid
          size={{ xs: 12, md: 4, lg: 6 }}
          component={Stack}
          sx={{
            backgroundImage: `url("/become_a_writer.jpg")`,
            backgroundSize: 'cover',
          }}
        />
      </Grid>
    </Card>
  );
}
